<template>
<div class="content-list" v-if="firstPayment.paid_to === 1">
  <span class="content-list-title bold" v-if="firstPayment.same_state !== 2">
    IGST {{firstPayment.igst_tax}} %:
    {{taxAmount}}
  </span>
  <span class="content-list-title bold" v-if="firstPayment.same_state === 2">
    CGST {{firstPayment.state_tax}} %:
    {{taxAmount}}
  </span> <br/>
  <span class="content-list-title bold" v-if="firstPayment.same_state === 2">
    {{ isUnionTerritory ? 'UGST' : 'SGST' }} {{firstPayment.state_tax}} %:
    {{taxAmount}}
  </span>
</div>
<div class="content-list" v-else>
  <span class="content-list-title bold">RCM {{firstPayment.igst_tax}}% :
    {{taxAmount}}
  </span>
</div>
</template>

<script>
import { isUgstApplicable } from 'pando-constants';

export default {
  name: 'GST',
  props: ['invoice', 'firstPayment'],
  data() {
    return {
      currentRoute: '',
    };
  },
  computed: {
    isUnionTerritory() {
      return this.$hasFeature && this.$hasFeature('ugst_support') &&
        this.invoice && this.invoice.tax &&
        this.invoice.tax.intra_state && isUgstApplicable(this.invoice.tax.destination);
    },
    taxAmount() {
      return this.$invoice.invoiceTax(this.invoice.order_payments, this.firstPayment);
    },
  },
};
</script>
